var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, state } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { BwElement } from './base/bw-element.js';
const LED_COUNT = 20;
let BwSlider = class BwSlider extends BwElement {
    constructor() {
        super(...arguments);
        this.min = 0;
        this.max = 100;
        this.step = 1;
        this.value = 0;
        this.disabled = false;
        this.bipolar = false;
        this.size = 'md';
        this._pos = 0; // 0..1
    }
    willUpdate(_c) {
        const range = this.max - this.min || 1;
        this._pos = Math.min(1, Math.max(0, (this.value - this.min) / range));
        this.style.setProperty('--bw-slider-pos', String(this._pos));
    }
    _emit(type, v) {
        this.dispatchEvent(new CustomEvent(`bw-slider-${type}`, {
            detail: { value: v }, bubbles: true, composed: true,
        }));
    }
    _onInput(e) { this.value = parseFloat(e.target.value); this._emit('input', this.value); }
    _onChange(e) { this.value = parseFloat(e.target.value); this._emit('change', this.value); }
    _leds() {
        const leds = [];
        // bipolar: light from center outward to _pos; unipolar: 0..pos
        for (let i = 0; i < LED_COUNT; i++) {
            const frac = (i + 0.5) / LED_COUNT;
            let on;
            if (this.bipolar) {
                on = frac >= Math.min(0.5, this._pos) && frac <= Math.max(0.5, this._pos);
            }
            else {
                on = frac <= this._pos;
            }
            leds.push(html `<i class="bw-slider-led ${on ? 'on' : ''}"></i>`);
        }
        return leds;
    }
    render() {
        const readout = this.format ? this.format(this.value) : nothing;
        return html `
      <span class="bw-slider-track">
        <span class="bw-slider-leds">${this._leds()}</span>
        <span class="bw-slider-shoe"></span>
        <input class="bw-slider-native" type="range"
          min=${this.min} max=${this.max} step=${this.step} .value=${String(this.value)}
          ?disabled=${this.disabled}
          aria-valuetext=${this.format ? this.format(this.value) : nothing}
          @input=${this._onInput} @change=${this._onChange}>
      </span>
      ${this.format ? html `<span class="bw-slider-readout">${readout}</span>` : nothing}
    `;
    }
};
__decorate([
    property({ type: Number })
], BwSlider.prototype, "min", void 0);
__decorate([
    property({ type: Number })
], BwSlider.prototype, "max", void 0);
__decorate([
    property({ type: Number })
], BwSlider.prototype, "step", void 0);
__decorate([
    property({ type: Number })
], BwSlider.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwSlider.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwSlider.prototype, "bipolar", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwSlider.prototype, "size", void 0);
__decorate([
    property({ attribute: false })
], BwSlider.prototype, "format", void 0);
__decorate([
    state()
], BwSlider.prototype, "_pos", void 0);
BwSlider = __decorate([
    customElement('bw-slider')
], BwSlider);
export { BwSlider };
//# sourceMappingURL=bw-slider.js.map